var EstimateStatus = {
  ACCEPTED: 0,
  PARTIALLY_ACCEPTED: 1,
  PENDING: 2,
  DECLINED: 3,
};

module.exports = EstimateStatus;
